import { cn } from '@Pages/pageRuntime/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const alertVariants = cva(
  'relative w-full rounded-lg border [&>svg]:absolute [&>svg]:text-foreground',
  {
    variants: {
      variant: {
        default: 'bg-background text-foreground [&>svg]:text-foreground',
        info: 'bg-informative/10 text-foreground border-informative/30 [&>svg]:text-informative',
        // Body text stays on the default foreground: --warning is tuned for solid fills and
        // does not clear contrast as text on its own tint.
        warning: 'bg-warning/10 text-foreground border-warning/30 [&>svg]:text-warning',
        success: 'bg-success/10 text-foreground border-success/30 [&>svg]:text-success',
        destructive:
          'border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive'
      },
      size: {
        default: 'px-4 py-3 text-sm [&>svg]:top-3.5 [&>svg]:left-4 [&>svg~*]:pl-7'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
);

const Alert = ({
  className,
  variant,
  ref,
  ...props
}: React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof alertVariants> & { ref?: React.Ref<HTMLDivElement> }) => (
  <div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props} />
);
Alert.displayName = 'Alert';

export { Alert };
